import { ContactDataDisplayModelFormGroup } from '../../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';
import { Component, OnInit, Input} from '@angular/core';
import {Validators } from '@angular/forms';
import { GlobalEnumerationsAceInformationsquelle } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enumerations-ace-informationsquelle';
import { EnumValue } from '@/core/models/enumvalue.model';
import { I18nService } from '@/core/services/i18nService';
import { StateService } from '@/core/services/state.service';
import { SectionService } from '@/core/services/section.service';
import { PortalContextService } from '@/core/services/portal-context.service';
@Component({
    selector: 'applicant-form',
    templateUrl: './applicant-form.component.html',
    styleUrls: ['./applicant-form.component.scss'],
    standalone: false
})
export class ApplicantFormComponent implements OnInit {
  @Input('form') contactDataForm: ContactDataDisplayModelFormGroup;

  public get informationsquelleList(): EnumValue[] {
    return this.translateservice.getEnumValues(GlobalEnumerationsAceInformationsquelle);
  }

  constructor(protected translateservice: I18nService, protected stateService: StateService, protected sectionService: SectionService, protected portalContextService: PortalContextService) { 
  }

  ngOnInit(): void {
    if (this.stateService.IsEndvalidationEnabled) {
      this.contactDataForm.Informationsquelle.addValidators(Validators.required);
      this.contactDataForm.markAllAsTouched();
    }
    this.contactDataForm.Antragsteller.AbweichendeAdresse.setValue(true);

    if (!this.portalContextService.isAnfrageStatusGrundInEntwurf() && this.portalContextService.isAnfrageInUeberarbeitung()) {
      if (this.sectionService.current()?.anstragstellerDatenUeberarbeiten == true) {
        if (this.contactDataForm.Ansprechpartner.ZuBearbeiten.value == false) {
          this.contactDataForm.Ansprechpartner.Firstname.disable();
          this.contactDataForm.Ansprechpartner.Lastname.disable();
          this.contactDataForm.Ansprechpartner.ContactInformation.EmailAddress.disable();
        }
        
        if (this.contactDataForm.Vertretungsberechtigter.ZuBearbeiten.value == false) {
          this.contactDataForm.Vertretungsberechtigter.Firstname.disable();
          this.contactDataForm.Vertretungsberechtigter.Lastname.disable();
          this.contactDataForm.Vertretungsberechtigter.ContactInformation.EmailAddress.disable();
        }
      }
      else {
        this.contactDataForm.disable();
      }
    }
  }
}
